<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Prijava {{shema}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
       <!-- <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
			-->

            <pridelovalec :pridelovalec="pridelovalec" :sezona="dataSezona.sezona" shema="IP" :kontrolaid="kontrolaid"
                    :podshema="kontrola.podrocjecertificiranja"></pridelovalec>
		
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="shraniKontrole" >Shrani</button>
				<button class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>


     <div class="display-flex pt-1">

    <div>
        <fieldset class="left-border-for-children">
           
            <div class="display-row mt-1 display-row-form" >
            <span>Kontrolna številka</span>
             <kinput disabled type="text" v-model="pridelovalec.kontrolnaStevilka"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Shema certificiranja</span>
             <kinput disabled type="text" value="Integrirana pridelava"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Področje</span>
            <kinput disabled type="text" v-model="kontrola.podrocjecertificiranja"/>
            
		</div>
        <div class="display-row mt-1 display-row-form" >
            <span>Status kontrole</span>
            <kinput disabled type="text" v-model="kontrola.status"/>
		</div>
        <div class="form-fieldset-header">
                <h2>Naloži kontrolni list</h2>
            </div>
	<div class="display-flex" style="align-items:center;gap:1rem;">  
			
			
			<label for="priponkaseznam" class="k-form-field">
				<upload
					:files="files"
					:batch="false"
					:multiple="false"
					:with-credentials="false"
					@add="onAdd"
					@remove="onRemove"
					@progress="onProgress"
					@statuschange="onStatusChange"
					@beforeupload="authorize"
					@beforeremove="authorize"
					:save-url="saveurl"
					:remove-url="removeurl"
                    />
			</label>
			<label v-if="kontrola.kontrolnilisti" for="prenesiseznam" class="k-form-field"></label>
			</div>
            <div v-if="napake&&napake.length>0" > 
                <h2>Seznam napak:</h2> 
                <ul v-if="napake">
                    <li v-for="napaka in napake">Vrstica {{napaka.row  }}: {{ napaka.napaka }}</li>
                </ul> 
                
            </div>
 

            </fieldset>
             </div>
             
               
          


           
                
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapActions,mapMutations } from 'vuex';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import {store} from '../store/index.js'
import { Checkbox } from "@progress/kendo-vue-inputs";
import { provideIntlService } from '@progress/kendo-vue-intl';
import PridelovalecKratko from './support/PridelovalecKratko';
import { pridelavaService } from '../services/pridelava.service';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';
import { kontrolaService } from '../services/kontrola.service';
import { Input } from '@progress/kendo-vue-inputs';

export default {
     components: {
        'kinput': Input,
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox,
    'Grid': Grid,
     'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
	  upload: Upload,
  },
    props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
			      dataSezona:this.sezona,
                   sezone:[],
            kontrola:{
                

            },
            napake:[],
            nacinprijaveip:[{naziv:"Pošta",id:0},{naziv:"E-pošta",id:1},{naziv:"Osebno",id:2}],
			vrstaprijaveip:[{naziv:"Prva prijava",id:0},{naziv:"Obnova prijave",id:1},{naziv:"Obnova prijave zaradi sprememb",id:2}],
			podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}],
            ipobsegcertificiranja:[],
			ipobsegcertificiranjafilter:{},
            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           files:[],
            iscipodizvajalca:'',
            iscipodizvajalcaerror:'',
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrstapridelave:["EK+K","EK-P","P"],
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[]
        }
    },
    computed: {
		
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        kontakt:{
            get(){
                var kontakt=this.pridelovalec?.kontakt?.find(k=>k.glavni);
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt?.find(k=>k.vloga=='nosilec kmg');
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt[0];

                return kontakt;
            }
        },
		obsegcertificiranja:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.ip.obseg;
            else
                return [];

          }
        },
        
        ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
    
      if(!this.shema)
        this.shema="IP";
	    this.naloziPodatke(this.shema,this.sezona,this.pridelovalecid);
      // this.naloziPodatke();
     
    },
	beforeRouteUpdate (to, from,next) {
    	this.naloziPodatke(to.params.shema,to.params.sezona,to.params.pridelovalecid,next);
	},
    methods: {
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...

			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid).then(k=>{
                store.dispatch('alert/success', "Kontrolni list je bil uspešno naložen!", { root: true });
                this.napake=[];
            }).catch(k=>{
                console.log("VLOVIM NAPAKO!");
                this.napake=k.napake;
                store.dispatch('alert/error', "Napaka pri nalaganju kontrolnega lista!", { root: true });

            })
              //this.save();
    },
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),

		authorize(event) {
			event.headers=authHeader();
		},
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.kontrola,'kontrolnilisti',{datotekaid:event.response?.response?._id,files:this.files});
      },
		spremeniobseg (event,podshema)  {
			console.log(event.target.value);
			//let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema);
            Vue.set(this.ip.prijava.obseg,podshema,[...event.target.value])
			console.log(this.ip.prijava.obseg);
        },
        dodajmanjkajocielementi(){
			console.log("PUSHAM")
            if(!this?.ip?.prijava?.manjkajocielementi)
                this.ip.prijava.manjkajocielementi=[];

            const newRecord = { id: this.ip.prijava.manjkajocielementi.length + 1,datumprejema:new Date(),vsebina:'',pregledal:'',edit:true };
            this.ip.prijava.manjkajocielementi.push(newRecord);
        }   ,
        removemanjkajocielementi(e){
        
                var index=this.ip.prijava.manjkajocielementi.indexOf(e);
                if(index>=0)
                        this.ip.prijava.manjkajocielementi.splice(index,1)

        },
        manjkajocielementichange: function (e) {
            e.dataItem[e.field]=e.value;

     
  
},

        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
        cancel(e){
			this.$router.push({ name: 'sheme', params: { sezona:sezona.sezona,shema:this.shema},query:{shema:this.shema,sezona:this.sezona} })
        },
       
		naloziPodatke (shema,sezona,pridelovalecid,next){
            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
         var thisComp=this;
        this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja)
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
				
        });
       
        this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{


            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
			//naloži kontrolo
            this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
			kontrolaService.loadOne(sezona,pridelovalecid,shema,thisComp.kontrolaid).then(
			data=>{
				/*
				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}
				*/
				Vue.set(thisComp,'kontrola',data);
                thisComp.files=thisComp.kontrola?.kontrolnilisti?.files;
				
				if(next)
                next();
			},
			err=>{}
			);
			
			
            
        } );   

            
            
           
            
      
      
        },
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
         sezonaChange(event) {
         
            const sezona = event.value;
            this.dataSezona=sezona;
            this.$router.push({ name: 'ipprijava', params: { sezona:sezona.sezona,shema:this.shema,pridelovalecid:this.pridelovalecid} })
            /*
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
             this.naloziPodatke();
              });

*/
          //  this.naloziPodatke();



        },
    }
};
</script>

<style scoped>

.izbranakategorija{
   background-color: var(--accent);
   
}
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>